import React, { useEffect, useRef, useState } from 'react';
import { DEFAULT_LIKE_TYPES, EMOJI_CATEGORIES } from '../../lib/reaction_emojis';

// @context TGW-1769 / TGW-1860 リアクションピッカー。既定の5種に加え、＋ボタンで
//   OS 標準の全絵文字（EMOJI_CATEGORIES）から選べる。BE は任意の絵文字（1書記素）を許可する。
export default function ReactionPicker({ onPick, onClose }) {
  const ref = useRef(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div
      className={`slackch-reaction-picker ${showAll ? 'slackch-reaction-picker--all' : ''}`}
      ref={ref}
    >
      {!showAll ? (
        <>
          {DEFAULT_LIKE_TYPES.map((type) => (
            <button key={type} type="button" onClick={() => onPick(type)}>
              {type}
            </button>
          ))}
          {/* ＋で全絵文字を開く */}
          <button
            type="button"
            className="slackch-reaction-more"
            title="他の絵文字"
            aria-label="他の絵文字"
            onClick={() => setShowAll(true)}
          >
            ＋
          </button>
        </>
      ) : (
        <div className="slackch-reaction-grid">
          {EMOJI_CATEGORIES.map((category) => (
            <div key={category.label} className="slackch-reaction-category">
              <div className="slackch-reaction-category-label">
                {category.label}
              </div>
              <div className="slackch-reaction-category-emojis">
                {category.emojis.map((emoji, i) => (
                  <button
                    key={`${category.label}-${i}`}
                    type="button"
                    onClick={() => onPick(emoji)}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
